import api from "@/libs/axios";
import * as ep from "./endpoints";

export default {
  namespaced: true,
  state: () => ({
    campaigns: [],
    detailsDonation: {},
    loadingDetailsDonation: false,
    loading: false,
    pagination: {},
  }),
  getters: {
    campaigns(state) {
      return state.campaigns;
    },
    detailsDonation(state) {
      return state.detailsDonation;
    },
    loading(state) {
      return state.loading;
    },
    loadingDetailsDonation(state) {
      return state.loadingDetailsDonation;
    },
    pagination(state) {
      return state.pagination;
    },
  },

  mutations: {
    setCampaigns(state, payload) {
      state.campaigns = payload;
    },
    setDetailsDonation(state, payload) {
      state.detailsDonation = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
  },
  actions: {
    async getCampaigns(context, payload) {
      context.state.loading = true;
      await api
        .post(ep.campaigns(payload.type), payload.data)
        .then((res) => {
          context.commit("setCampaigns", res.data.data);
          context.commit("setPagination", res.data.pagination);
          context.state.loading = false;
        })
        .catch((err) => {});
    },
    async getDetailsDonation(context, payload) {
      context.state.loadingDetailsDonation = true;
      await api
        .get(ep.detailsDonation(payload.id))
        .then((res) => {
          context.commit("setDetailsDonation", res.data.data);
          context.state.loadingDetailsDonation = false;
        })
        .catch((err) => {});
    },
  },
};
